<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        <b-icon icon="motorcycle" v-if="locker.lockerInfo.hasCourier"></b-icon>
        <b-icon
          icon="hand-paper"
          v-else
          style="position: relative; top: 3px; left: 8px;"
        ></b-icon>
        &nbsp;&nbsp;&nbsp;{{ $t("lockerDelivery.newDelivery") }}
      </p>
    </header>

    <section class="modal-card-body">
      <delivery-form :locker="locker" @get-lockers="getLockers" />
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
import deliveryForm from "./DeliveryForm.vue";

export default {
  props: ["locker"],

  components: {
    deliveryForm
  },

  methods: {
    getLockers() {
      this.$emit("get-lockers");
    }
  }
};
</script>

<style scoped>
#delivery {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
